export default "__VITE_ASSET__CwNUv4Ig__"